<template>
    <Head title="Role Play Setup" />
    <div class="relative grow flex flex-col overflow-clip max-h-full background">
        <div class="grow overflow-y-auto overflow-x-hidden min-h-0 py-6 px-6 lg:px-16">
            <div class="mx-auto max-w-[1000px]">
                <div class="flex gap-4 items-center my-10">
                    <CoachingModeMarble class="w-10 h-10" />
                    <BasePageTitle title="Set up your role play" />
                </div>
                <RolePlayPreview class="mb-4" />
                <div class="border border-valence-grey-300 rounded-xl">
                    <RolePlaySetupForm :initial-data="initial_persona" :errors="errors" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LeftSidebarLayout from "~vue/layouts/LeftSidebarLayout.vue";
export default { layout: LeftSidebarLayout };
</script>

<script setup>
import { Head } from "@inertiajs/vue3";
import BasePageTitle from "~vue/components/BasePageTitle.vue";
import CoachingModeMarble from "~vue/components/navigation/CoachingModeMarble.vue";
import RolePlayPreview from "~vue/components/RolePlayPreview.vue";
import RolePlaySetupForm from "~vue/components/RolePlaySetupForm.vue";
import { inject, onMounted, onUnmounted } from "vue";

const { $setEventContext } = inject("globalProperties");
const { event_context } = defineProps({
    initial_persona: {
        type: Object,
        default: () => ({}),
    },
    errors: {
        type: Object,
        default: () => ({}),
    },
    event_context: {
        type: Object,
        default: () => ({}),
    },
});

onMounted(() => {
    $setEventContext(event_context);
});
onUnmounted(() => {
    $setEventContext({});
});
</script>

<style scoped>
.background {
    background: radial-gradient(40% 15% at 15% 105%, rgba(255, 197, 61, 0.5) 0%, rgba(255, 197, 61, 0) 100%),
        radial-gradient(40% 15% at 50% 105%, rgba(254, 40, 144, 0.24) 0%, rgba(254, 40, 144, 0) 100%),
        radial-gradient(40% 15% at 85% 105%, rgba(169, 32, 203, 0.24) 0%, rgba(169, 32, 203, 0) 100%);
}
</style>
